// The URLs of the object pages: a list, one record, and a related list's
// "View all" page. The object key doubles as the route segment.

import type { ObjectKey } from '../navigation';
import { NEW_PRODUCT_ROUTE, OBJECTS } from '../navigation';

const KEYS = new Set<string>(OBJECTS.map((o) => o.key));

export function isObjectKey(value: string): value is ObjectKey {
  return KEYS.has(value);
}

export function listPath(object: ObjectKey): string {
  return `/${object}`;
}

export function recordPath(object: ObjectKey, id: string): string {
  return `/${object}/${encodeURIComponent(id)}`;
}

/** Objects whose New opens a page of its own instead of the New dialog: a product is set up end to end. */
export const CREATE_PAGES: Partial<Record<ObjectKey, string>> = { products: NEW_PRODUCT_ROUTE };

/** Objects a record page offers Clone on: any the app creates on a plain new-record page. */
export function clonable(object: ObjectKey): boolean {
  return CREATE_PAGES[object] === undefined;
}

/** The new-record page, started as a copy of `from`. */
export function clonePath(object: ObjectKey, from: string): string {
  return `/${object}/new?from=${encodeURIComponent(from)}`;
}

export function relatedPath(object: ObjectKey, id: string, relation: string): string {
  return `${recordPath(object, id)}/related/${encodeURIComponent(relation)}`;
}

/**
 * The library's record links (`recordHref`): the record's URL, or null for an
 * object without a record page (users), so its name stays plain text.
 */
export function recordHref(object: string, id: string): string | null {
  return isObjectKey(object) && id !== '' ? recordPath(object, id) : null;
}
